import { component } from 'picoapp'

export default component((node) => {
    const trigger = document.querySelector('[data-toggle-collection-filter-drawer]')
    const closers = node.querySelectorAll('[data-toggle]')

    const open = () => {
        node.classList.add('is-active')

        setTimeout(() => {
            node.classList.add('filter-is-visible')
            document.body.classList.add('filter-is-visible')
        }, 50)
    }

    const close = () => {
        node.classList.remove('filter-is-visible')
        document.body.classList.remove('filter-is-visible')
        setTimeout(() => {
            node.classList.remove('is-active')
        }, 400)
    }

    trigger.addEventListener('click', (event) => {
        event.preventDefault()

        open()
    })

    closers.forEach((button) => {
        button.addEventListener('click', close)
    })
})
